export const FORM_ID = 'ProfileGoals--Debt-Management';

export const UPSERT_GOAL_URL = '/Consumer/GoalUpdate/SaveDebtManagementGoal';

export interface DebtManagementGoalData {}

export interface FormValues {
  assetBucketingIndices: number[];
}
